import { Row as RowComponent } from "./row"
import { Column } from "./column"

type Row = typeof RowComponent & {
  Column: typeof Column
}

export const Row = RowComponent as Row
Row.Column = Column
